import {Column, HeaderProps} from 'react-table'
import SelectionHeader from '../../../utils/components/table-content/SelectionHeader'
import {ListViewContext} from '../../../utils/contextProvider/ListViewProvider'
import {SelectionCell} from '../../../utils/components/table-content/SelectionCell'
import {PropsWithChildren} from 'react'
import {CustomHeader} from '../../../utils/components/table-content/CustomHeader'
import ActionCell from '../../../utils/components/table-content/ActionCell'
import {ISubmenu} from './_model'

const submenuListColumn = (handleSelect: (id: number) => void): ReadonlyArray<Column<ISubmenu>> => [
  {
    Header: (props) => <SelectionHeader tableProps={props} context={ListViewContext} />,
    id: 'selection',
    Cell: ({...props}) => (
      <SelectionCell id={props.data[props.row.index].id_submenu} context={ListViewContext} />
    ),
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ISubmenu>>) => (
      <CustomHeader tableProps={props} title='submenu name' className='min-w-100px' />
    ),
    id: 'submenu_name',
    accessor: 'submenu_name',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ISubmenu>>) => (
      <CustomHeader tableProps={props} title='Action' className='min-w-100px text-end' />
    ),
    id: 'action',
    Cell: ({...props}) => (
      <ActionCell id={props.data[props.row.index].id_submenu} selectItem={handleSelect} />
    ),
  },
]

export default submenuListColumn
